// @flow
import React, { PureComponent } from 'react';
import type { EventType } from 'types/Event';
import EventListElement from 'components/event/EventListElement';
import HiddenEventListElement from 'components/event/HiddenEventListElement';

type Props = {
  events: Array<EventType>,
  noHidden?: boolean
};

class EventListRow extends PureComponent<Props> {
  props: Props;

  renderFirstEvents = (number: number): any => {
    return this.props.events
      .slice(0, number)
      .map((event, index) => <EventListElement key={index} event={event} isFirst={index === 0} />);
  };

  render() {
    const { events } = this.props;
    if (events.length === 1) return <EventListElement event={events[0]} isFirst />;
    if (events.length === 2 || this.props.noHidden)
      return <div className="events__group">{this.renderFirstEvents(events.length)}</div>;
    else
      return (
        <div className="events__group">
          {this.renderFirstEvents(2)}
          <HiddenEventListElement events={events.slice(2)} />
        </div>
      );
  }
}

export default EventListRow;
